import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import BlueCheckbox from 'components/atoms/BlueCheckbox'
import CloseButton from 'components/atoms/buttons/CloseButton'
import AcceptButton from 'components/atoms/buttons/AcceptButton'

import { formatDate, LOCAL_DATE_FORMAT } from 'utils/date'

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    justifyContent: 'space-between',
    padding: `${theme.spacing(1)}px 0`,
    boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
  },
  column: {
    flexGrow: 1,
    display: 'flex',
    position: 'relative',
  },
  actions: {
    width: 75,
    display: 'flex',
    justifyContent: 'space-between',
  },
  selectable: {
    position: 'relative',
  },
  checkbox: {
    left: 10,
  },
  disabled: {
    pointerEvents: 'none',
    opacity: 0.4,
  },
})

class RequestRow extends React.PureComponent {
  getContent = (rowData, column) => {
    const content = rowData[column.field]
    const {
      classes,
      onRequestDeny,
      onRequestAccept,
      onItemSelect,
      selectedPeople,
    } = this.props

    switch (column.format) {
      case 'approval':
        return (
          <div
            className={classNames(
              classes.actions,
              selectedPeople.length > 0 && classes.disabled
            )}>
            <CloseButton
                className={classes.closeButton}
                iconClassName={classes.closeIcon}
                onClick={() => onRequestDeny([rowData])}
            />
            <AcceptButton
                className={classes.acceptButton}
                iconClassName={classes.acceptIcon}
                onClick={() => onRequestAccept([rowData])}
            />
          </div>
        )
      case 'checkbox':
        return (
          <BlueCheckbox
              checked={selectedPeople.indexOf(rowData) > -1}
              className={classes.checkbox}
              onChange={event =>
              column.selectable && onItemSelect(rowData, event)
            }
          />
        )
      case 'fullDate':
        return (
          <Typography>{formatDate(content, LOCAL_DATE_FORMAT)}</Typography>
        )
      case 'name':
      default:
        return <Typography>{content}</Typography>
    }
  };

  render() {
    const {
      classes, columns, data, onItemSelect
    } = this.props

    return (
      <div className={classes.root}>
        {columns && columns.map((column, index) => {
          return (
            <div
              key={index}
              style={{ maxWidth: column.width, justifyContent: column.align }}
              className={classes.column}
              onClick={() =>
                column.selectable &&
                column.field !== 'select' &&
                onItemSelect(data[column.field])
              }>
              {this.getContent(data, column)}
            </div>
          )
        })}
      </div>
    )
  }
}

RequestRow.propTypes = {
  data: PropTypes.object,
  onClick: PropTypes.func,
  columns: PropTypes.array,
  classes: PropTypes.object,
  onItemSelect: PropTypes.func,
  onRequestDeny: PropTypes.func,
  selectedPeople: PropTypes.array,
  onRequestAccept: PropTypes.func,
  onCheckboxSelect: PropTypes.func,
}

export default withStyles(styles)(RequestRow)



// WEBPACK FOOTER //
// ./src/containers/people/PeopleRequests/RequestRow.js